<div class="toast-wrap" data-testid="toast-container">
  @for (t of notif.toasts(); track t.id) {
    <div class="toast" [class.success]="t.type==='success'" [class.error]="t.type==='error'"
         [class.info]="t.type==='info'" [class.warning]="t.type==='warning'"
         [attr.data-testid]="'toast-' + t.type">
      <i class="fa-solid" [class.fa-check-circle]="t.type==='success'"
         [class.fa-circle-exclamation]="t.type==='error' || t.type==='warning'"
         [class.fa-circle-info]="t.type==='info'"></i>
      <span>{{ t.message }}</span>
    </div>
  }
</div>
